// workedHours excludes unpaid meals; paid rest breaks remain working time.
export function requiredRestBreakCount(workedHours, regulation) {
  const minimum = Number(regulation.minimum_shift_hours);
  const interval = Number(regulation.trigger_hours);
  if (
    workedHours < minimum ||
    (workedHours === minimum && !regulation.trigger_inclusive)
  ) {
    return 0;
  }
  const second = Number(regulation.second_break_hours ?? minimum + interval);
  const inclusive = regulation.subsequent_trigger_inclusive ?? true;
  if (workedHours < second || (workedHours === second && !inclusive)) {
    return 1;
  }
  const intervals = (workedHours - second) / interval;
  return inclusive ? 2 + Math.floor(intervals) : 1 + Math.ceil(intervals);
}

export function restBreakDurationHours(regulation) {
  return Number(regulation?.required_break_minutes || 10) / 60;
}

export function isSupportedPaidBreakDuration(duration) {
  return Number.isFinite(duration) &&
    [10, 15].some((minutes) => Math.abs(duration - minutes / 60) <= 1e-3);
}
